export class EmisorPassRequest {
   emisorId: string;
   oldPass: string;
   newPass: string;
}
